import type { CommandItem } from "./commandItem";

/** Index `step` places away from `index` in a list of `count`, wrapping around (0 for an empty list). */
export function wrapIndex(index: number, step: 1 | -1, count: number): number {
  return count ? (index + step + count) % count : 0;
}

/** Index of the last result (0 for an empty list). */
export function lastIndex(count: number): number {
  return Math.max(0, count - 1);
}

/**
 * Heading to show above the result at `index`: its group when it starts a new group, and only while
 * browsing (no query), since search results are ranked rather than grouped. Empty for no heading.
 */
export function groupHeadingAt(results: CommandItem[], index: number, query: string): string {
  if (query.trim()) return "";
  const group = results[index]?.group ?? "";
  const previousGroup = index > 0 ? (results[index - 1]?.group ?? "") : "";
  return group !== previousGroup ? group : "";
}

/** DOM id of a result's option, for `aria-activedescendant`. */
export function commandOptionId(listId: string, item: CommandItem): string {
  return `${listId}-${item.id}`;
}
